import { useMutation } from "@apollo/client/react";
import { Box, IconicButton, TruncatedText } from "@nulogy/components";
import { GridBox4, StyledInput, StyledText } from "components/common/EditableListStyledComponents";
import FieldRow from "components/common/FieldRow";
import Form from "components/controls/Form";
import { UpdateDowntimeReason } from "hooks/apollo/downtimeReason/downtimeReason.gql";
import React, { useState } from "react";

export default function DowntimeReason({ downtimeReason, onDelete }) {
  const [editing, setEditing] = useState(false);
  const [updateDowntimeReason] = useMutation(UpdateDowntimeReason, { onCompleted: () => setEditing(false) });

  const { id, reason, code } = downtimeReason;

  const handleCancel = (onReset) => {
    onReset();
    setEditing(false);
  };

  const handleSave = (updatedDowntimeReason) =>
    updateDowntimeReason({
      variables: {
        code: updatedDowntimeReason.code,
        id: updatedDowntimeReason.id,
        reason: updatedDowntimeReason.reason,
      },
    });

  return (
    <>
      {!editing && (
        <GridBox4 data-testid="downtime-reason">
          <StyledText data-testid="downtime-reason-reason">
            <TruncatedText fullWidth>{reason}</TruncatedText>
          </StyledText>
          <StyledText data-testid="downtime-reason-code">
            <TruncatedText fullWidth>{code}</TruncatedText>
          </StyledText>
          <IconicButton icon="edit" onClick={() => setEditing(true)} type="button">
            Edit
          </IconicButton>
          <IconicButton icon="delete" onClick={() => onDelete(downtimeReason.id)} type="button">
            Delete
          </IconicButton>
        </GridBox4>
      )}
      {editing && (
        <Form initialValues={{ code, id, reason }} onSave={handleSave}>
          {({ dirty, handleReset }) => (
            <FieldRow data-testid="downtime-reason-row-editing" marginBottom="none">
              <GridBox4>
                <StyledInput field="reason" placeholder="Reason" />
                <StyledInput field="code" placeholder="Code" />
                <Box paddingTop="x1">
                  <IconicButton disabled={!dirty} icon="check" type="submit">
                    Save
                  </IconicButton>
                </Box>
                <Box paddingTop="x1">
                  <IconicButton icon="close" onClick={() => handleCancel(handleReset)} type="button">
                    Cancel
                  </IconicButton>
                </Box>
              </GridBox4>
            </FieldRow>
          )}
        </Form>
      )}
    </>
  );
}
